import Vue from 'vue'
import Vuex from 'vuex'
import 'es6-promise/auto'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

function initialState() {
  return {
    /* DATI TRATTATIVA ROTTAME */
    trattativa: {},
    trattativaForm: {},
    nuovaTrattativa: false,
    duplicaTrattativa: false,
    /* DIPENDENTI TERZI */
    DIP_Ricerca: {},
    DIP_Dipendente: {},
    DIP_new: false,
    DIP_Documento: {},
    /* DIPENDENTI TERZI - SITUAZIONE DOC */
    DOC_Ricerca: {},
    GA_Documento: {},
    /* DIPENDENTI TERZI - ASSOCIA DIP */
    ASD_Ricerca: {},
    /* DIPENDENTI TERZI - CONTESTAZIONI */
    CON_Ricerca: {},
    CON_Contestazione: {},
    /* ACQUISTI - RICHIESTE DI QUOTAZIONE */
    RDQ_Ricerca: {},
    RDQ_Quotazione: {}
  }
}

export default new Vuex.Store({
  state: initialState(),
  mutations: {
    set(state, payload) {
      state[payload.key] = payload.value
    },
    setValue(state, obj) {
      state[obj.form][obj.field] = obj.value
    },
    reset(state) {
      const initState = initialState()
      Object.keys(initState).forEach(key => {
        state[key] = initState[key]
      })
    },
    /* METODI ROTTAME */
    setCodFornRottame(state, codForn) {
      state.TRAACQ_fornitore = codForn
    },
    /* METODI TRATTATIVA ROTTAME */
    setTrattativa(state, trattativa) {
      state.trattativa = trattativa
    },
    setTrattativaForm(state, form) {
      state.trattativaForm = form
    },
    setIfNuovaTrattativa(state, value) {
      state.nuovaTrattativa = value
    },
    setIfDuplicaTrattativa(state, value) {
      state.duplicaTrattativa = value
    },
    /* METODI ANAG: DIPENDENTI */
    setDesFornitore(state, value) {
      state.DIP_Ricerca.desFornitore = value
    }
  },
  actions: {
    /* ACTIONS GENERICHE */
    ifObject(context, campo) {
      if (Object.keys(context.state[campo]).length !== 0 && context.state[campo].constructor === Object) {
        return true
      }
      return false
    },
    ifValue(context, campo) {
      if (context.state[campo] !== '' && context.state[campo] !== null && context.state[campo] !== undefined) {
        return true
      }
      return false
    }
  },
  plugins: [
    createPersistedState({
      storage: window.sessionStorage
    })
  ]
})



// WEBPACK FOOTER //
// ./src/components/Store.js